import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../UploadDocument/apiUrl';
import { toast } from '@ohif/ui-next';
import DesktopSidebar from './Sidebar/SidebarDesktop'; // Nuevo componente
import MobileBottomBar from './Sidebar/SidebarMobile';
import UploadTemplateModal from './bottom/UploadTemplate'; // Nuevo componente para el modal

const SidebarNavigation = ({ onFilterToggle }) => {
  const navigate = useNavigate();
  const [rolUsuario, setRolUsuario] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);

  // --- Nueva Lógica: Estado de Sincronización DICOM ---
  const [syncStatus, setSyncStatus] = useState({ isSyncing: false, nextSyncTime: null });
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    // Solo consultar y mostrar si es app local (http, no https)
    if (window.location.protocol !== 'http:') return;

    const checkStatus = async () => {
      try {
        const res = await fetch(`${apiUrl}/api/dicom/sync-status`);
        if (res.ok) {
          const data = await res.json();
          setSyncStatus(data);
        }
      } catch (err) {
        console.warn('No se pudo obtener el estado de sincronización');
      }
    };

    checkStatus();
    const interval = setInterval(checkStatus, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (window.location.protocol !== 'http:' || !syncStatus || !syncStatus.nextSyncTime || syncStatus.isSyncing) return;

    const interval = setInterval(() => {
      const diff = syncStatus.nextSyncTime - Date.now();
      if (diff <= 0) {
        setTimeLeft('Iniciando...');
      } else {
        const minutes = Math.floor(diff / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);
        setTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [syncStatus]);

  // --- Lógica del archivo y subida ---

  const handleFileChange = event => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (!file) {
      alert('Por favor selecciona un archivo.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(apiUrl + '/api/documentos/document/template', {
        method: 'POST',
        body: formData,
      });
      const res = await response.json();
      if (response.status !== 200) {
        toast.warning(res.message || 'Error al subir el archivo.');
      } else {
        setShowModal(false);
        toast.success(res.message || 'Archivo subido con éxito.');
      }
    } catch (error) {
      toast.error(error.message || 'Error al subir el archivo.');
    }
  };

  // --- Lógica de inicialización y navegación ---

  useEffect(() => {
    const localStr = localStorage.getItem('usuario');
    const session = localStr ? JSON.parse(localStr) : null;
    const tiposUsuario = session ? session.user.role : '';

    setRolUsuario(tiposUsuario);
  }, []);

  const onToggleTemplate = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleNavigation = path => {
    navigate(path);
  };

  // --- Renderizado de los componentes de UI ---

  return (
    <>
      <DesktopSidebar
        rolUsuario={rolUsuario}
        onFilterToggle={onFilterToggle}
        onNavigation={handleNavigation}
        onToggleTemplate={onToggleTemplate}
      />

      <MobileBottomBar
        rolUsuario={rolUsuario}
        onFilterToggle={onFilterToggle}
        onNavigation={handleNavigation}
        onToggleTemplate={onToggleTemplate}
      />

      <UploadTemplateModal
        showModal={showModal}
        closeModal={closeModal}
        handleSubmit={handleSubmit}
        handleFileChange={handleFileChange}
        apiUrl={apiUrl}
      />

      {window.location.protocol === 'http:' && syncStatus && (
        <div className="fixed bottom-[165px] right-4 sm:bottom-4 sm:right-4 bg-black/80 text-white px-4 py-2 rounded-lg shadow-lg z-50 flex items-center gap-2 text-sm border border-gray-600 backdrop-blur-sm">
          {syncStatus.isSyncing ? (
            <>
              <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
              <span>Sincronizando DICOM...</span>
            </>
          ) : (
            <>
              <div className="w-3 h-3 border-2 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
              <span>Próxima sync en: {timeLeft || '--:--'}</span>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default SidebarNavigation;
